"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "font-bold" };
const _hoisted_3 = { class: "font-bold" };
const _hoisted_4 = {
    key: 0,
    class: "text-center p-5 font-bold"
};
const _hoisted_5 = { class: "flex items-center justify-center gap-2 font-bold" };
const _hoisted_6 = { class: "text-left font-bold" };
const _hoisted_7 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_8 = { class: "text-left" };
const _hoisted_9 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_10 = {
    key: 0,
    class: "text-right"
};
const _hoisted_11 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_12 = { class: "text-center" };
const _hoisted_13 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_14 = { class: "text-center" };
const _hoisted_15 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_16 = { class: "text-center" };
const _hoisted_17 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_18 = ["onClick"];
const vue_3 = require("vue");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const i18n_1 = require("../../common/i18n");
const shop_1 = require("../../common/utils/shop");
const toastStore_1 = require("../../stores/toast/toastStore");
const securityStore_1 = require("../../stores/security/securityStore");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'UploadedOrderInvoices',
    props: {
        openOrder: {
            type: Object,
        },
    },
    setup(__props) {
        var _a, _b, _c, _d, _e, _f;
        const props = __props;
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const router = (0, vue_router_1.useRouter)();
        const orderInvoices = (0, vue_3.ref)([]);
        const uploadedOrderInvoiceListFields = (0, vue_3.ref)([
            {
                key: "originalFilename",
                label: (_a = (0, i18n_1.trans)("filename_order_invoice_list", "Filename", "uploaded_order_invoices")) !== null && _a !== void 0 ? _a : "Filename",
                value: "originalFilename",
            },
            {
                key: "invoiceId",
                label: (_b = (0, i18n_1.trans)("invoice_id_order_invoice_list", "Invoice ID", "uploaded_order_invoices")) !== null && _b !== void 0 ? _b : "Invoice ID",
                value: "invoiceId",
            },
            {
                key: "grossTotal",
                label: (_c = (0, i18n_1.trans)("date_order_invoice_list", "Date", "uploaded_order_invoices")) !== null && _c !== void 0 ? _c : "Date",
                value: "grossTotal",
            },
            {
                key: "paymentMode",
                label: (_d = (0, i18n_1.trans)("payment_mode_order_invoice_list", "Payment Mode", "uploaded_order_invoices")) !== null && _d !== void 0 ? _d : "Payment Mode",
                value: "paymentMode",
            },
            {
                key: "createdDatetime",
                label: (_e = (0, i18n_1.trans)("uploaded_at_order_invoice_list", "Uploaded At", "uploaded_order_invoices")) !== null && _e !== void 0 ? _e : "Uploaded At",
                value: "createdDatetime",
            },
            {
                key: "uploaderEmail",
                label: (_f = (0, i18n_1.trans)("uploader_email_order_invoice_list", "Uploader Email", "uploaded_order_invoices")) !== null && _f !== void 0 ? _f : "Uploader Email",
                value: "uploaderEmail",
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const paymentMode = (paymentModeId) => {
            var _a, _b;
            switch (paymentModeId) {
                case 1:
                    return ((_a = (0, i18n_1.trans)("cash_on_delivery", "Cash On Delivery", "uploaded_order_invoices")) !== null && _a !== void 0 ? _a : "Cash On Delivery");
                case 2:
                    return ((_b = (0, i18n_1.trans)("transfer_credit_card", "Transfer, Credit Card", "uploaded_order_invoices")) !== null && _b !== void 0 ? _b : "Transfer, Credit Card");
            }
            return "";
        };
        const getOrderInvoices = async () => {
            if (!props.openOrder)
                return;
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "admin_order_invoices_api", query: { orderId: props.openOrder.id } }).href);
                const invoices = Array.isArray(response["hydra:member"]) ? response["hydra:member"].filter(i => i["@type"] === "OrderInvoice") : [];
                orderInvoices.value = invoices;
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const deleteOrderInvoice = async (orderInvoiceId) => {
            var _a;
            const confirmMsg = (_a = (0, i18n_1.trans)("delete_order_invoice_confirm", "Are you sure?", "uploaded_order_invoices")) !== null && _a !== void 0 ? _a : "Are you sure?";
            if (!confirm(confirmMsg))
                return;
            try {
                await (0, fetch_1.default)(router.resolve({ name: "admin_order_invoices_api", params: { id: orderInvoiceId } }).href, { method: "DELETE" });
                toastStore.addToast({
                    message: (0, i18n_1.trans)("order_invoice_deleted_successfully", "Order invoice deleted successfully!", "uploaded_order_invoices"),
                    type: "success",
                    timer: 5,
                });
                await getOrderInvoices();
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        (0, vue_3.onBeforeMount)(() => {
            getOrderInvoices();
        });
        return (_ctx, _cache) => {
            return (__props.openOrder !== undefined)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", null, [
                        (0, vue_2.createElementVNode)("span", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("order_id", "Order ID", "uploaded_order_invoices")) + ":", 1),
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(__props.openOrder.id), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", null, [
                        (0, vue_2.createElementVNode)("span", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delivery_address", "Delivery Address", "uploaded_order_invoices")) + ":", 1),
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(__props.openOrder.shippingName) + " " + (0, vue_2.toDisplayString)(__props.openOrder.shippingZip) + " " + (0, vue_2.toDisplayString)(__props.openOrder.shippingCity) + ", " + (0, vue_2.toDisplayString)(__props.openOrder.shippingStreet), 1)
                    ]),
                    (orderInvoices.value.length === 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("no_uploaded_order_invoice_yet", "There is no uploaded order invoice yet.", "uploaded_order_invoices")), 1))
                        : (0, vue_2.createCommentVNode)("", true),
                    (orderInvoices.value.length > 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ResponsiveTable_vue_1.default, {
                            key: 1,
                            fields: uploadedOrderInvoiceListFields.value,
                            "onUpdate:fields": _cache[0] || (_cache[0] = ($event) => ((uploadedOrderInvoiceListFields).value = $event)),
                            items: orderInvoices.value,
                            striped: "",
                            condensed: "",
                            panel: ""
                        }, {
                            "head-originalFilename": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("filename", "Filename", "uploaded_order_invoices")), 1)
                            ]),
                            "cell-originalFilename": (0, vue_2.withCtx)(({ item: orderInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)(orderInvoice.originalFilename), 1)
                            ]),
                            "head-invoiceId": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("invoice_id", "Invoice ID", "uploaded_order_invoices")), 1)
                            ]),
                            "cell-invoiceId": (0, vue_2.withCtx)(({ item: orderInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)(orderInvoice.invoiceId), 1)
                            ]),
                            "head-grossTotal": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("gross_total", "Gross Total", "uploaded_order_invoices")), 1)
                            ]),
                            "cell-grossTotal": (0, vue_2.withCtx)(({ item: orderInvoice }) => {
                                var _a;
                                return [
                                    ((0, vue_2.unref)(securityStore).authenticatedUser !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(orderInvoice.grossTotal, (_a = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _a === void 0 ? void 0 : _a.customer.id)), 1))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ];
                            }),
                            "head-paymentMode": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_11, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("payment_mode", "Payment Mode", "uploaded_order_invoices")), 1)
                            ]),
                            "cell-paymentMode": (0, vue_2.withCtx)(({ item: orderInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_12, (0, vue_2.toDisplayString)(paymentMode(orderInvoice.paymentMode)), 1)
                            ]),
                            "head-createdDatetime": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_13, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("uploaded_at", "Uploaded At", "uploaded_order_invoices")), 1)
                            ]),
                            "cell-createdDatetime": (0, vue_2.withCtx)(({ item: orderInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)(orderInvoice.createdDatetime), 1)
                            ]),
                            "head-uploaderEmail": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("uploader_email", "Uploader Email", "uploaded_order_invoices")), 1)
                            ]),
                            "cell-uploaderEmail": (0, vue_2.withCtx)(({ item: orderInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_16, (0, vue_2.toDisplayString)(orderInvoice.uploaderEmail), 1)
                            ]),
                            "cell-actions": (0, vue_2.withCtx)(({ item: orderInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-rounded btn-primary btn-link",
                                        onClick: ($event) => (deleteOrderInvoice(orderInvoice.id))
                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete_uploaded_order_invoice", "Delete Uploaded Order Invoice", "uploaded_order_invoices")), 9, _hoisted_18)
                                ])
                            ]),
                            _: 1
                        }, 8, ["fields", "items"]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
